import { Link } from "react-router-dom"; // Use 'to' instead of 'href'


export default function Service() {
    return (
        <>
             <section className="service-5-section">
                <div className="auto-container">
                    <div className="row no-gutters">
                        <div className="col-lg-4 col-md-6 column">
                            <div className="service-5-block-wrap">
                                <div className="service-5-block wow fadeInLeft" >
                                    <div className="service-5-icon"><i className="icon-6"></i></div>
                                    <h4 className="service-5-title">Assisted Living</h4>
                                    <p className="service-5-text">Are you on the lookout for a customized/quality care partner that is completely tailored to your needs and is fully committed to your well-being? Newran Support Services provides you with exactly that.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 column">
                            <div className="service-5-block-wrap">
                                <div className="service-5-block wow fadeInLeft" >
                                    <div className="service-5-icon"><i className="icon-7"></i></div>
                                    <h4 className="service-5-title">Our Philosophy</h4>
                                    <p className="service-5-text">Our philosophy is simple: independence, dignity and connection should be a part of the lives of everybody.  </p>
                                </div>                        
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 column">
                            <div className="service-5-block-wrap">
                                <div className="service-5-block wow fadeInLeft" >
                                    <div className="service-5-icon"><i className="icon-8"></i></div>
                                    <h4 className="service-5-title">Hand-in-Hand</h4>
                                    <p className="service-5-text">Newran Support Services is a NDIS Registered Service provider, hand-in-hand with the National Disability Insurance Scheme (NDIS) State and Commonwealth Government requirements, promises to provide you with the safe and high-quality disability support service that you seek. </p>
                                </div>                        
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
